export default "__VITE_ASSET__C3Wb9oU6__"